import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-90fbf482"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "metric-item el-card" }
const _hoisted_2 = { class: "metric-label" }
const _hoisted_3 = { class: "metric-value" }
const _hoisted_4 = { class: "metric-item el-card" }
const _hoisted_5 = { class: "metric-label" }
const _hoisted_6 = { class: "metric-value" }
const _hoisted_7 = { class: "metric-item el-card" }
const _hoisted_8 = { class: "metric-label" }
const _hoisted_9 = { class: "metric-value" }
const _hoisted_10 = { class: "metric-item el-card" }
const _hoisted_11 = { class: "metric-label" }
const _hoisted_12 = { class: "metric-value" }

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import Card from '@/views/dashboard/_components/card/card.vue'
import TerminalDistributionChart from './_components/terminal-distribution-chart.vue'
import RankingChart from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import type { RankingItem } from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import { TerminalDistributionItem } from '../types'
import HardwareWarningZone from '../hardware-warning-zone/hardware-warning-zone.vue'
import {
  SensitivefilesendHomepageStatService,
  OsResponseData,
  HomepageAuthSoftStatusResponseData,
} from '@/views/dashboard/overview/service'
import type { StatsTerminalRes } from '@/views/dashboard/home/home.service'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'asset-status-zone',
  setup(__props) {

const router = useRouter()

const injector = useReflectiveInjector([SensitivefilesendHomepageStatService])
const homepageStatService = injector.get(SensitivefilesendHomepageStatService)

const summaryData = ref({
  licensedSoftware: 0,
  installedTerminals: 0
})

const terminalStats = ref({ deployCount: 0, notDeployedCount: 0 })

const terminalLoading = ref(false)
const terminalData = ref<TerminalDistributionItem[]>([])

const softwareLoading = ref(false)
const softwareChartData = ref<RankingItem[]>([])

function loadTerminalAssetCard() {
  terminalLoading.value = true
  Promise.all([
    homepageStatService.getTerminalOsDistribution(),
    homepageStatService.getHomepageStatsTerminal(),
  ])
    .then(([osRes, statsRes]) => {
      const rawOs = osRes as OsResponseData & { data?: OsResponseData }
      const payloadOs = rawOs.data ?? rawOs
      const list = payloadOs.os_version_list || []
      terminalData.value = list.map(item => ({
        name: item.system_name || String(item.system_type),
        value: item.count,
      }))

      const rawStats = statsRes as StatsTerminalRes & { data?: StatsTerminalRes }
      const s = rawStats.data ?? rawStats
      terminalStats.value = {
        deployCount: s.deploy_count ?? 0,
        notDeployedCount: s.un_join_count ?? 0,
      }
    })
    .catch(() => {
      terminalData.value = []
      terminalStats.value = { deployCount: 0, notDeployedCount: 0 }
    })
    .finally(() => {
      terminalLoading.value = false
    })
}

function loadAuthSoftStatus() {
  softwareLoading.value = true
  homepageStatService
    .getHomepageAuthSoftStatus()
    .then(res => {
      const raw = res as HomepageAuthSoftStatusResponseData & { data?: HomepageAuthSoftStatusResponseData }
      const d = raw.data ?? raw
      summaryData.value = {
        licensedSoftware: d.auth_soft_count ?? 0,
        installedTerminals: d.soft_terminal_count ?? 0
      }
      softwareChartData.value = (d.list ?? []).map(item => ({
        name: item.name ?? '--',
        count: item.value ?? 0
      }))
    })
    .catch(() => {
      summaryData.value = { licensedSoftware: 0, installedTerminals: 0 }
      softwareChartData.value = []
    })
    .finally(() => {
      softwareLoading.value = false
    })
}

onMounted(() => {
  loadTerminalAssetCard()
  loadAuthSoftStatus()
})

function handleViewMoreTerminal() {
  router.push('/dashboard/client')
}

function handleViewMoreSoftware() {
  router.push('/dashboard/genuine-software')
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Card, {
    size: "first",
    "background-color": "var(--cm-color-card-bg)",
    border: "",
    title: _ctx.$t('overviewZone.assetZoneTitle'),
    description: _ctx.$t('overviewZone.assetZoneDesc')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 16 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: _unref(IS_JP_ONLY_BUILD) ? 12 : 6,
            class: "custom-card"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(Card, {
                size: "second",
                title: _ctx.$t('overviewZone.terminalAssetDistribution'),
                "on-view-more": handleViewMoreTerminal,
                style: {"height":"100%","box-sizing":"border-box","display":"flex"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, {
                    gutter: 16,
                    class: "cm-ui-mb15"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 12,
                        class: "cm-ui-mb10"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('overviewZone.metricDeployedTerminals')), 1),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(terminalStats.value.deployCount), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('overviewZone.metricNotDeployedTerminals')), 1),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(terminalStats.value.notDeployedCount), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(TerminalDistributionChart, {
                    data: terminalData.value,
                    "center-title": _ctx.$t('overviewZone.chartTerminalCount'),
                    style: {"margin":"auto"},
                    unit: _ctx.$t('overviewZone.unitTai')
                  }, null, 8, ["data", "center-title", "unit"])
                ]),
                _: 1
              }, 8, ["title"])), [
                [_directive_loading, terminalLoading.value]
              ])
            ]),
            _: 1
          }, 8, ["span"]),
          (!_unref(IS_JP_ONLY_BUILD))
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 9,
                class: "custom-card"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(Card, {
                    size: "second",
                    title: _ctx.$t('overviewZone.softwareAssetTitle'),
                    "on-view-more": handleViewMoreSoftware,
                    style: {"height":"100%","box-sizing":"border-box"}
                  }, {
                    titleAfter: _withCtx(() => [
                      _createVNode(_component_el_tag, {
                        size: "small",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 16 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            span: 12,
                            class: "cm-ui-mb10"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('overviewZone.metricLicensedSoftware')), 1),
                                _createElementVNode("div", _hoisted_9, _toDisplayString(summaryData.value.licensedSoftware), 1)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('overviewZone.metricGenuineInstallTerminals')), 1),
                                _createElementVNode("div", _hoisted_12, _toDisplayString(summaryData.value.installedTerminals), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(RankingChart, {
                        emptyHeight: "292px",
                        data: softwareChartData.value,
                        style: {"padding":"0","border":"none"},
                        "show-time-range": false,
                        "card-size": "second",
                        unit: _ctx.$t('overviewZone.unitPiece')
                      }, null, 8, ["data", "unit"])
                    ]),
                    _: 1
                  }, 8, ["title"])), [
                    [_directive_loading, softwareLoading.value]
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_col, {
            span: _unref(IS_JP_ONLY_BUILD) ? 12 : 9,
            class: "custom-card"
          }, {
            default: _withCtx(() => [
              _createVNode(HardwareWarningZone)
            ]),
            _: 1
          }, 8, ["span"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "description"]))
}
}

})